import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { InputField, LoaderButton } from 'components/molecules'
import * as Yup from 'yup'

const propTypes = {
  onSubmit: PropTypes.func.isRequired
}

const salesReconcileSchema = Yup.object().shape({
  bank_transaction_date_from : Yup.date().required('Required'),
  bank_transaction_date_to   : Yup.date().required('Required')
})

/**
 * Form to input date-range before downloading sales reconcile csv
 * @param {Function} onSubmit - function to submit form
 */
const BankTransactionSalesReconcileDownloadForm = ({ onSubmit }) => (
  <Formik
    initialValues={{
      bank_transaction_date_from : '',
      bank_transaction_date_to   : ''
    }}
    validationSchema={ salesReconcileSchema }
    onSubmit={ onSubmit }
  >
    {
      (formikBag) => (
        <Form>
          <InputField
            type='date'
            label={ 'Bank Transaction From' }
            name={ 'bank_transaction_date_from' }
            labelClassName='small text-gray-light text-capitalize'
          />
          <InputField
            type='date'
            label={ 'Bank Transaction To' }
            name={ 'bank_transaction_date_to' }
            labelClassName='small text-gray-light text-capitalize'
          />

          <LoaderButton
            color='primary'
            type='submit'
            disabled={ formikBag.isSubmitting }
            isLoading={ formikBag.isSubmitting }
            text='Submit'
          />
        </Form>
      )
    }
  </Formik>
)

BankTransactionSalesReconcileDownloadForm.propTypes = propTypes

export default BankTransactionSalesReconcileDownloadForm